import React, {useEffect, useState} from "react";
import {Localizer} from "infrastructure/localization/localizer";
import {useRouteMatch} from "react-router-dom";
import {Loading} from "../../core/components/loading/loading";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {forloebReducer, ForloebSliceState} from "../../core/forloebSlice";
import {KompetenceCardList, KompetenceCardListType} from "./cards/kompetenceCardList";
import {KompetenceOverview} from "./details/kompetenceOverview";
import {
    kompetenceCardReducer,
    KompetenceCardState,
    scrollToActiveKompetence,
    setActiveLaegekompetenceMeta,
    toggleLaegekompetenceListRefreshPing
} from "./cards/kompetenceCardSlice";
import {RoutePaths} from "../../infrastructure/routes";
import {LaegekompetenceMeta} from "../../core/sharedmodels/kompetence/laegekompetenceMeta";
import {HttpClientService} from "../../services/httpClient/httpClientService";
import {FileDownloadHandler} from "../../services/api/logbogFile/fileDownloadHandler";
import {AsyncButton} from "../../core/components/button/asyncButton";
import {LogbogExportApi} from "../../services/api/logbogExport/logbogExportApi";
import {AccountService} from "../../services/account/accountService";
import {DropdownButton} from "../../core/components/dropdownButton/dropdownButton";
import {ToSelectOptions_Deprecated} from "../../core/sharedmodels/forSelectModel";
import {ForloebHeader} from "../../core/components/headerCards/forloebHeader";
import useRefreshablePage from "core/infrastructure/routing/hooks/useRefreshablePage";
import ForloebSpecificPageWrapper from "core/componentsPage/forloeb/forloebSpecificPageWrapper";
import useUser from "core/hooks/useUser";
import {userKompetenceQueryParams} from "infrastructure/route/queryParams";
import useScreenResolution from "core/hooks/useScreenResolution";
import classNames from "classnames";
import useStamdataApi from "core/hooks/useStamdataApi";
import useLinkHistory from "infrastructure/route/useLinkHistory";
import {HelpLinks} from "../../core/components/link/helpLinks";
import {LinkPlacementEnum} from "../../core/components/link/LinkPlacementEnum";
import useInitUddannelseslaegeForloebState from "core/hooks/useInitUddannelseslaegeForloebState";
import {kompetenceOverviewTypeEnum} from "./kompetenceOverviewTypeEnum";
import useUserSettings, {useInitializeViaUserSettings} from "../../core/hooks/useUserSettings";
import {BrugerIndstillingTypeKeyEnum} from "../../core/sharedmodels/brugerIndstilling/brugerIndstillingTypeKeyEnum";
import {ResizableContainer} from "../../core/sharedmodels/resizer/resizableContainer";

const exportApi = new LogbogExportApi(new HttpClientService(), new AccountService(), new FileDownloadHandler());

export type KompetencerPageLinkHistoryState = {
    laegeKompetenceId?: string;
    brugerMaalbeskrivelseId?: string;
}

export const KompetencerPage = () => {
    const routeMatch = useRouteMatch<userKompetenceQueryParams>();
    const dispatch = useAppDispatch();
    const { history, locationState, clearLocationState } = useLinkHistory<KompetencerPageLinkHistoryState>();
    const { pageKey } = useRefreshablePage();
    const { currentUser } = useUser();
    const { isMobile } = useScreenResolution();
    const { stamdataMaalbeskrivelseApi } = useStamdataApi();

    const kompetenceCardState = useAppSelector(kompetenceCardReducer) as KompetenceCardState;
    const forloebSliceState = useAppSelector(forloebReducer) as ForloebSliceState;

    const [isLoading, setIsLoading] = useState(true);

    const [brugerMaalbeskrivelserSelectOptions, setBrugerBrugerMaalbeskrivelserSelectOptions] = useState<{ key: string; value: string; }[]>([]);
    const [selectedBrugerMaalbeskrivelseName, setSelectedBrugerMaalbeskrivelseName] = useState(Localizer.global_vaelgMaalbeskrivelse());
    const [selectedBrugerMaalbeskrivelse, setSelectedBrugerMaalbeskrivelse] = useState<string>(forloebSliceState.forloebState.brugerMaalbeskrivelseId);
    const [currentBrugerMaalbeskrivelse, setCurrentBrugerMaalbeskrivelse] = useState<string>(forloebSliceState.forloebState.brugerMaalbeskrivelseId);
    const [kompetenceView, setKompetenceView] = useState(kompetenceOverviewTypeEnum.DefaultView)
    const [mobileView, setMobileView] = useState<boolean>(false)

    const uddannelseslaegeId = routeMatch.params.uddannelseslaege;

    const [initialWith, setInitialWith] = useState<number | undefined>(undefined);
    const { userSettingsIsLoading, getUserSettingValue, setUserSettingValue } = useUserSettings();

    useInitializeViaUserSettings(userSettingsIsLoading, () => {
        const savedPageView = getUserSettingValue(BrugerIndstillingTypeKeyEnum.PageKompetencerViewOption, kompetenceOverviewTypeEnum.DefaultView);
        const savedWidth = getUserSettingValue(BrugerIndstillingTypeKeyEnum.PageKompetencerViewWidth, 50);
        setKompetenceView(savedPageView);
        setInitialWith(savedWidth);
    });

    useEffect(() => {
        setMobileView(kompetenceView === kompetenceOverviewTypeEnum.WideView || isMobile);
    },[isMobile, kompetenceView])

    const activeKompetenceFromLink = !!locationState?.isLink && !!locationState?.laegeKompetenceId;
    const activeKompetenceId = activeKompetenceFromLink ? locationState?.laegeKompetenceId : kompetenceCardState?.activeLaegekompetenceMeta?.laegekompetenceId;

    const { initializedToCorrectLaege: isForloebStateInitializedToCorrectLaege } = useInitUddannelseslaegeForloebState(uddannelseslaegeId, locationState?.brugerMaalbeskrivelseId);

    useEffect(() => {
        if (!kompetenceCardState) {
            dispatch(scrollToActiveKompetence(false));
            dispatch(setActiveLaegekompetenceMeta(new LaegekompetenceMeta().ToState()));
        }
        setIsLoading(false);
    }, [dispatch, kompetenceCardState]);

    const getLaegekompetencerPdf = (): Promise<void> => {
        return exportApi.getPdfKompetencer(uddannelseslaegeId, forloebSliceState.forloebState.brugerMaalbeskrivelseId);
    }

    useEffect(() => {
        if (activeKompetenceFromLink) {
            if (mobileView && !isLoading && activeKompetenceId) {
                // On mobile: go directly to active-kompetence-page (when coming from a link):
                const routeParamaters = [uddannelseslaegeId, activeKompetenceId];
                history.push(RoutePaths.KompetencerOverview(routeParamaters).url);
            }
            dispatch(scrollToActiveKompetence(true));
        }

    }, [activeKompetenceFromLink, activeKompetenceId, dispatch, history, isLoading, mobileView, uddannelseslaegeId])

    useEffect(() => {
        const initializeAndFetchBrugermaalbeskrivelse = async () => {
            if (!!forloebSliceState.forloebState.brugerMaalbeskrivelseId && isForloebStateInitializedToCorrectLaege) {
                const currentBrugerMaalbeskrivelse = await stamdataMaalbeskrivelseApi.getBrugerMaalbeskrivelse(forloebSliceState.forloebState.brugerMaalbeskrivelseId);
                setCurrentBrugerMaalbeskrivelse(currentBrugerMaalbeskrivelse.id);
                setSelectedBrugerMaalbeskrivelse(currentBrugerMaalbeskrivelse.id);

                const brugerMaalbeskrivelser = await stamdataMaalbeskrivelseApi.getBrugerMaalbeskrivelseSelectByUddannelse(uddannelseslaegeId, forloebSliceState.forloebState.stillingId, forloebSliceState.forloebState.brugerMaalbeskrivelseId);
                let brugerMaalbeskrivelserSelectOptions = ToSelectOptions_Deprecated(brugerMaalbeskrivelser, [currentBrugerMaalbeskrivelse.id]);
                brugerMaalbeskrivelserSelectOptions = brugerMaalbeskrivelserSelectOptions.sort((a, b) => (a.selected === b.selected) ? 0 : a.selected ? -1 : 1);
                setSelectedBrugerMaalbeskrivelseName(brugerMaalbeskrivelserSelectOptions.find(x => x.key === currentBrugerMaalbeskrivelse.id)?.value ?? Localizer.global_vaelgMaalbeskrivelse());
                setBrugerBrugerMaalbeskrivelserSelectOptions(brugerMaalbeskrivelserSelectOptions);
            }
        }
        initializeAndFetchBrugermaalbeskrivelse();
    }, [forloebSliceState.forloebState.brugerMaalbeskrivelseId, forloebSliceState.forloebState.stillingId, isForloebStateInitializedToCorrectLaege, stamdataMaalbeskrivelseApi, uddannelseslaegeId])

    async function getLaegekompetencerToShow(brugerMaalbeskrivelseId: string | undefined) {
        if (brugerMaalbeskrivelseId) {
            clearLocationState(); //If we were linked with a laegeKompetence, clear this state.

            const brugerMaalbeskrivelseInDropdown = brugerMaalbeskrivelserSelectOptions.find(x => x.key === brugerMaalbeskrivelseId)?.value;
            setSelectedBrugerMaalbeskrivelseName(brugerMaalbeskrivelseInDropdown ?? Localizer.global_vaelgMaalbeskrivelse());
            setSelectedBrugerMaalbeskrivelse(brugerMaalbeskrivelseId);
            dispatch(setActiveLaegekompetenceMeta(kompetenceCardState.activeLaegekompetenceMeta));
            dispatch(toggleLaegekompetenceListRefreshPing())
        }
    }

    const onKompetenceViewChange = (viewOptionType: kompetenceOverviewTypeEnum) => {
        setKompetenceView(viewOptionType);
        setUserSettingValue(BrugerIndstillingTypeKeyEnum.PageKompetencerViewOption, viewOptionType)
    };

    const onKompetenceWidthChange = (widthPercentage: number) => {
        setUserSettingValue(BrugerIndstillingTypeKeyEnum.PageKompetencerViewWidth, widthPercentage)
    };

    const getSecondDivContent = () => {
        return selectedBrugerMaalbeskrivelse && (
            <div className="h-100 overflow-auto">
                {!kompetenceCardState.isLoadingList && (
                    <KompetenceOverview
                        isReadOnly={selectedBrugerMaalbeskrivelse !== currentBrugerMaalbeskrivelse ||
                            kompetenceCardState?.activeLaegekompetenceMeta?.brugerMaalbeskrivelseId !== currentBrugerMaalbeskrivelse}
                        currentBrugerMaalbeskrivelse={currentBrugerMaalbeskrivelse}
                        getCurrentBrugerMaalbeskrivelse={(currentBrugerMaalbeskrivelse) => getLaegekompetencerToShow(currentBrugerMaalbeskrivelse)}
                        laegeKompetenceId={activeKompetenceId}
                        uddannelseslaegeId={uddannelseslaegeId}
                    />
                )}
            </div>
        );
    }

    const getFirstDivContent = () => {
        return <KompetenceCardList
            kompetenceListType={KompetenceCardListType.KompetencerByBruger}
            selectedBrugerMaalbeskrivelseId={selectedBrugerMaalbeskrivelse}
        />;
    }

    return (
        <Loading isLoading={isLoading} text={Localizer.kompetencePage_getKompetencer()} key={pageKey}>
            <ForloebSpecificPageWrapper hideAllContent={!isForloebStateInitializedToCorrectLaege}>
                {!mobileView &&
                    <ForloebHeader hideSeUddannelseAndForloebDetails={true}/>
                }

                <div className="row">
                    {kompetenceCardState?.activeLaegekompetenceMeta === undefined &&
                        <div className="col-sm-12">
                            <div className="alert alert-info">
                                <b>{Localizer.kompetencePage_noKompetencerOnForloeb()}</b>
                            </div>
                        </div>
                    }
                </div>

                {kompetenceCardState?.activeLaegekompetenceMeta !== undefined &&
                <div className="card top-level-container">
                    <div className={classNames("card-header", isMobile ? "flex-container-column wrap" : "flex-space")}>
                        <div className={classNames("d-flex align-items-center", isMobile && "flex-align-l flex-row")}>
                            <h3 className="card-title margin-right-s">{Localizer.global_kompetencer()}</h3>
                            <HelpLinks linkPlacement={LinkPlacementEnum.KompetencePage}/>
                        </div>
                        <div className={classNames("d-flex", isMobile && "flex-align-l margin-bottom-m flex-row")}>
                            {!isMobile &&
                                <div className="btn-group margin-right-m">
                                    <button type="button"
                                            className={`btn ${kompetenceView === kompetenceOverviewTypeEnum.DefaultView ? "btn-primary" : "btn-default"}`}
                                            aria-label="Left"
                                            onClick={() => onKompetenceViewChange(kompetenceOverviewTypeEnum.DefaultView)}>
                                        {Localizer.global_standard()}
                                    </button>
                                    <button type="button"
                                            className={`btn ${kompetenceView === kompetenceOverviewTypeEnum.WideView ? "btn-primary" : "btn-default"}`}
                                            aria-label="Right"
                                            onClick={() => onKompetenceViewChange(kompetenceOverviewTypeEnum.WideView)}>
                                        {Localizer.global_list()}
                                    </button>
                                </div>
                            }

                            {!currentUser.IsKonsulentForLaegeligVidereuddannelse() &&
                                <AsyncButton clickFunction={getLaegekompetencerPdf} buttonText={Localizer.GetPdf()}
                                             waitText={Localizer.gettingPdf()}/>
                            }

                            <div className={classNames(isMobile ? "margin-left-s" : "margin-left-m")}>
                                <DropdownButton
                                    id={"kompetenceside-dropdown-btn"}
                                    dropdownHeader={Localizer.global_maalbeskrivelser()}
                                    emptyDropdownHeader={Localizer.global_ingenMaalbeskrivelser()}
                                    objectClicked={(selectedOption: string) => getLaegekompetencerToShow(selectedOption)}
                                    showEditButton={false}
                                    selectOptions={brugerMaalbeskrivelserSelectOptions}
                                    buttonSelected={selectedBrugerMaalbeskrivelseName !== Localizer.global_vaelgMaalbeskrivelse()}
                                    selectedObjectName={selectedBrugerMaalbeskrivelseName}
                                    highlightSelectedItem={brugerMaalbeskrivelserSelectOptions.length > 1}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"row no-gutters" + (!mobileView ? " height-75-vh" : "")}>
                        {!mobileView && !(kompetenceView === kompetenceOverviewTypeEnum.WideView) && initialWith &&
                            <ResizableContainer
                                firstDivContent={getFirstDivContent()}
                                secondDivContent={getSecondDivContent()}
                                initialWidth={initialWith}
                                onWidthChange={onKompetenceWidthChange}
                            />
                        }

                        {mobileView &&
                            <div className="col-12">
                                <KompetenceCardList
                                    mobileView={mobileView}
                                    kompetenceListType={KompetenceCardListType.KompetencerByBruger}
                                    selectedBrugerMaalbeskrivelseId={selectedBrugerMaalbeskrivelse}
                                    showCompactView={kompetenceView === kompetenceOverviewTypeEnum.WideView && !isMobile}
                                />
                            </div>
                        }
                    </div>
                </div>
                }
            </ForloebSpecificPageWrapper>
        </Loading>
    );
}

